'use client';

import { UserProfile } from 'types';
import SellerBooksRow from '~/components/seller-books-row';

interface SellerBookClientProps {
  seller: UserProfile | null;
}

/**
 * Client component that renders the SellerBooksRow
 */
export default function SellerBookClient({ seller }: SellerBookClientProps) {
  if (!seller) return null;
  return <SellerBooksRow seller={seller} />;
}
